<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Vendor</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Loyalty Point System</b>
      /
      <router-link :to="{ name: 'vendor-view' }">Vendor List</router-link>
      /
      <b>Redeemed Item List</b>
    </div>
    <!-- End of breadcrumbs -->
    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12">
        <button class="btn btn-primary" @click="print">Print</button>
      </div>

      <div
        class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
      >
        <span class="m-auto"></span>
        <div class="btn-group" role="group">
          <button
            class="btn btn-secondary"
            id="btn-active"
            :class="{ 'change-background': clickActive }"
            @click="activeClicked"
            type="button"
          >
            Redeemed
          </button>
          <button
            class="btn btn-secondary"
            id="btn-inactive"
            :class="{ 'change-background': clickMonthly }"
            @click="reportMonthlyClicked"
            type="button"
          >
            Monthly
          </button>
          <button
            class="btn btn-secondary"
            id="btn-inactive"
            :class="{ 'change-background': clickProduct }"
            @click="reportProductClicked"
            type="button"
          >
            Product
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12"></div>

      <div
        class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
      >
        <span class="m-auto"></span>
        <div class="btn-group" role="group"></div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- <p>Add new banner and company detail to be shown on Takaful Brunei Mobile App</p> -->

        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <div id="active" class>
              <h4 class="card-title mb-3">
                <b v-if="clickActive">Active</b>
                <b v-else>Report</b>
              </h4>

              <!-- Active -->
              <div v-if="clickActive" class="table-responsive">
                <table
                  id="active_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Redeemed By</th>
                      <th>Points Redeemed</th>
                      <th>Price Redeemed</th>
                      <th>View Product</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(list, index) in lists" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <router-link :to="goTo(list.ic_number)">{{
                          list.referral_id
                        }}</router-link>
                      </td>
                      <td>{{ list.points_redeemed }}</td>
                      <td>$ {{ list.price_redeemed }}</td>
                      <td>
                        <router-link
                          class="btn btn-primary btn-rounded btn-block"
                          :to="redirect(list.redeemable_id)"
                          >View Product</router-link
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="clickMonthly || clickProduct">
                <div class="row mb-3">
                  <div class="col-12 col-lg-6 col-sm-12"></div>

                  <div
                    class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
                  >
                    <span class="m-auto"></span>
                    <!-- Year -->
                    <div class="col-6">
                      <div class="form-group">
                        <label>Year</label>
                        <select class="form-control" v-model="filter_year">
                          <option v-for="(year, index) in years" :key="index">{{
                            year
                          }}</option>
                        </select>
                      </div>

                      <div class="form-group">
                        <button class="btn btn-primary" @click="applyFilter()">
                          Filter
                        </button>
                        &nbsp;
                        <button
                          id="btnAll"
                          class="btn btn-primary d-none"
                          @click="removeFilter()"
                        >
                          All
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="printGraph">
                  <h4 v-if="clickMonthly" class="text-center">
                    <b>Total Redeemed For {{ year }}</b>
                  </h4>
                  <h4 v-else class="text-center">
                    <b>Total Products Redeemed For {{ year }}</b>
                  </h4>
                  <GChart
                    v-if="clickMonthly"
                    type="ColumnChart"
                    :data="columnData"
                    :options="columnOptions"
                  />
                  <GChart
                    v-if="clickProduct"
                    type="ColumnChart"
                    :data="productData"
                    :options="productOptions"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { GChart } from "vue-google-charts";

export default {
  name: "vendor-redeem-list",
  components: { GChart },

  data() {
    return {
      lists: [],
      columnData: [],
      productData: [],
      chart: [],

      columnOptions: {
        title: "",
        height: 600,
        legend: "bottom",
        vAxis: { title: "Total Price Redeemed ($)" },
        hAxis: { title: "Month" }
      },

      productOptions: {
        title: "",
        height: 600,
        legend: "bottom",
        vAxis: { title: "No. Products Redeemed" },
        hAxis: { title: "Product Names" }
      },

      clickActive: true,
      clickMonthly: false,
      clickProduct: false,

      year: 0,
      years: [],
      filter_year: ""
    };
  },

  methods: {
    async loadData() {
      if (!this.checkToken()) {
        return;
      }

      let id = this.$route.params.id;

      try {
        let result = await axios.get(
          axios.lpsURL + "/point/redeem/vendor/" + id + "?entity_type=1",
          {
            headers: {
              Authorization: "Bearer " + this.checkToken()
            }
          }
        );
        this.lists = result.data.redeem;
      } catch (error) {
        console.log(error);
      }
    },

    checkToken() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token === null) {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;
      return token;
    },

    createDatatable() {
      $("#active_tbl").DataTable({
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3]
            }
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3]
            }
          }
        ]
      });
    },

    goTo(ic_no) {
      return "/customer/" + ic_no;
    },

    redirect(id) {
      let vendor_id = this.$route.params.id;
      return "/lps/vendor/product/details/" + vendor_id + "/" + id;
    },

    activeClicked() {
      this.clickActive = true;
      this.clickMonthly = false;
      this.clickProduct = false;
      setTimeout(() => {
        this.createDatatable();
      }, 50);
    },

    reportMonthlyClicked() {
      this.clickActive = false;
      this.clickMonthly = true;
      this.clickProduct = false;
    },

    reportProductClicked() {
      this.clickActive = false;
      this.clickMonthly = false;
      this.clickProduct = true;
    },

    loadGraph() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id;
      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(
            axios.lpsURL + "/point/redeem/vendor/demographic?entity_id=" + id,
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.allData = res.data;
            this.columnData = this.allData.Bar_Chart;
          });
      }
    },

    getProduct() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id;
      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(
            axios.lpsURL +
              "/point/redeem/vendor/product/demographic?entity_id=" +
              id,
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.productData = res.data.Bar_Chart;
          });
      }
    },

    //print graph
    print() {
      // Pass the element id here
      this.$htmlToPaper("printGraph");
    },

    loadYearFilter() {
      let date = new Date();
      let start_date = 2020;
      let current_year = date.getFullYear();

      this.year = current_year;

      // Past 5 year
      for (let i = start_date; i < current_year + 1; i++) {
        this.years.push(i);
      }
    },

    removeFilter() {
      $("#btnAll").addClass("d-none");

      this.filter_year = "";
      this.years = [];

      this.loadYearFilter();

      this.loadData();
    },

    applyFilter() {
      $("#btnAll").removeClass("d-none");

      let id = this.$route.params.id;

      // Declare filters
      let year = "";

      if (this.filter_year.length != 0) {
        year = "&filter_year=" + this.filter_year;
        this.year = this.filter_year;
      }

      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(
            axios.lpsURL +
              "/point/redeem/vendor/demographic?entity_id=" +
              id +
              year,
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.columnData = res.data.Bar_Chart;
          });

        axios
          .get(
            axios.lpsURL +
              "/point/redeem/vendor/product/demographic?entity_id=" +
              id +
              year,
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.productData = res.data.Bar_Chart;
          });
      }
    }
  },

  async created() {
    await this.loadData();
    this.loadYearFilter();
    this.loadGraph();
    this.getProduct();
    this.createDatatable();
  }
};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}
</style>
